<template>
  <div
    class="panel"
    :class="[
      type ? 'panel--' + type : '',
      padding ? 'panel--padding' : '',
      height ? 'panel--fixed' : '',
    ]"
    :style="'height:' + height"
  >
    <div class="panel-h" v-if="title">
      <slot name="title">
        <h2 :title="istip ? title : ''">
          <slot name="icon">
            <svgicon :name="icon" class="panel-icon" v-if="icon"></svgicon>
          </slot>
          {{ title }}
        </h2>
        <slot name="title-r"></slot>
        <span class="panel-tips" v-if="tips">{{ tips }}</span>
        <div class="panel-tools" v-if="tools">
          <slot name="tools"></slot>
        </div>
        <div class="panel-link" v-if="link">
          <el-button icon="el-icon-arrow-right" @click="linkTo()"></el-button>
        </div>
      </slot>
    </div>
    <div class="panel-c">
      <slot></slot>
    </div>
    <div class="panel-f" v-if="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "panel",
  props: {
    type: String,
    title: String,
    tips: String,
    link: Boolean,
    tools: Boolean,
    icon: String,
    footer: Boolean,
    padding: Boolean,
    height: String,
    istip: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    linkTo() {
      this.$emit("link-to");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.panel {
  position: relative;
  overflow: hidden;
  border-radius: $--border-radius-large;
  border: 1px solid $--border-color-light;
  background: #fff;
  // box-shadow: 0px 3px 5px 0px rgba(darken($--color-primary, 50%), 0.1);
  margin-bottom: $--base-padding;
  display: flex;
  flex-direction: column;
  &-h {
    position: relative;
    border-bottom: 1px solid rgba($--border-color-light, 0.4);
    padding: 0 $--base-padding;
    line-height: 56px;
    font-size: $--font-size-large;
    display: flex;
    justify-content: space-between;
    h2 {
      width: 100%;
      font-weight: bold;
      // white-space: nowrap;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      // display: flex;
      // align-items: center;
    }
    div {
      // font-size: $--font-size-large;
    }
  }
  &-icon {
    position: relative;
    top: -1px;
    display: inline-block;
    vertical-align: middle;
    width: 21px;
    height: 21px;
    margin-right: 0.5em;
    // stroke: $--color-primary;
    // fill: none;
    fill: $--color-primary;
    stroke: none;
  }
  &-tips {
    float: right;
    // text-align: right;
    font-size: $--font-size-small;
    color: $--color-text-regular;
    font-weight: normal;
    margin-left: 1em;
  }
  &-link {
    float: right;
    margin-left: 1em;
    .el-button {
      padding: 4px 4px;
      border-radius: 4px;
    }
  }
  &-tools {
    float: right;
    // width: 100%;
    text-align: right;
    margin-left: 1.2em;
    .el-button {
      padding: 7px;
      margin-left: 15px;
      i {
        font-size: $--font-size-large;
      }
    }
  }
  &-c {
    position: relative;
    // flex: 1;
    // min-height: 10px;
    // overflow: auto;
    // @extend %scroll-dark;
  }
  &-f {
    position: relative;
    border-top: 1px solid $--border-color-base;
    padding: 15px $--base-padding;
  }
  &--dark {
    // background: $--color-black;
    color: #fff;
    border: 0;
    // padding: $--base-padding;
    .panel-h {
      border-color: rgba(#fff, 0.1);
      background: $--color-black;
    }
    .panel-c {
      background: $--color-black;
    }
    .panel-f {
      background: $--color-black;
      border-color: rgba(#fff, 0.1);
      // margin: 0 (-$--base-padding) (-$--base-padding);
    }
  }
  &--colorful {
    border: 0;
    background: #f5f7fb;
    background-image: linear-gradient(
        -39deg,
        rgba(245, 186, 178, 0.4) 0%,
        rgba(255, 255, 255, 0) 50%
      ),
      linear-gradient(
        219deg,
        rgba(249, 173, 220, 0.4) 0%,
        rgba(255, 255, 255, 0) 50%
      ),
      linear-gradient(180deg, #eaf4fa 0%, #f8f2e9 100%);
    .panel-h {
      // background: $--background-color-light;
    }
    .panel-c {
      // background: $--background-color-light;
    }
    .panel-f {
      // background: $--background-color-light;
    }
  }
  &--gray {
    // background: $--background-color-light;
    background: #f5f7fb;
    background-image: linear-gradient(
      169deg,
      rgba(236, 16, 45, 0.03) 0%,
      rgba(236, 16, 45, 0) 41%
    );
  }
  &--toolbar {
    border: 0;
    background: $--background-color-light;
    border-radius: 32px;
  }
  &--padding {
    .panel-c {
      padding: $--base-padding;
    }
  }
  &--fixed {
    .panel-c {
      flex: 1;
      min-height: 10px;
      overflow-y: auto;
    }
  }
  &--chart {
    .panel-c {
      overflow: hidden;
    }
  }
}

@media screen and (max-width: $--lg) {
  .panel {
    margin-bottom: 10px;
    &-h {
      font-size: $--font-size-base;
    }
    &-tips {
      font-size: $--font-size-extra-small;
    }
  }
}
</style>
